import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { getClassNames } from '../index.classNames';
import { Label, TextField, Text } from '@fluentui/react';
import _ from 'lodash';
import ScrollablePaneHistory from '../../../../components/scrollablePaneHistory/index';
import { Document } from '../../../../models/document';
import { NumericFormat }from 'react-number-format';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { getSelectedProject } from '../../../../redux/selectors/project';
import { Project } from '../../../../models/project';
import { getHistoryName, getPurposeLabel } from '../../../../utils/functions';

export interface DetailsProps extends RouteComponentProps, WithTranslation {
    document: Document,
    project?: Project
}

class Details extends React.Component<DetailsProps & RouteComponentProps> {
    constructor(props: DetailsProps) {
        super(props);   
    }
    render(){
        const { project, document, t, history } = this.props;
        const styles = getClassNames();
        const historyName = getHistoryName(history);
        return (
            <>
                <div className={styles.tabContainer}>           
                    <div style={{marginBottom: 30}}><Text variant='xLarge' nowrap>{t('Details')}</Text></div>    
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 10}}>
                        {document.description &&
                            <TextField 
                                readOnly
                                label={t("Description 1")} 
                                autoComplete={'off'} 
                                value={document.description} 
                                title={document.description}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }   
                        {document.description2 &&
                            <TextField 
                                readOnly
                                label={t("Description 2")} 
                                autoComplete={'off'} 
                                value={document.description2} 
                                title={document.description2}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }     
                        {document.projectDocumentNumber &&
                            <TextField 
                                readOnly
                                label={t("Project Doc.Number")} 
                                autoComplete={'off'} 
                                value={document.projectDocumentNumber} 
                                title={document.projectDocumentNumber}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }       
                        {document.d3documentId &&
                            <TextField 
                                readOnly
                                label={t("D3 Doc.Id")} 
                                autoComplete={'off'} 
                                value={document.d3documentId} 
                                title={document.d3documentId}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }                     
                        {document.authoringStatus &&
                            <TextField 
                                readOnly
                                label={t("Authoring status")} 
                                autoComplete={'off'} 
                                value={document.authoringStatus} 
                                title={document.authoringStatus}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.language &&
                            <TextField 
                                readOnly
                                label={t("Language")} 
                                autoComplete={'off'} 
                                value={document.language} 
                                title={document.language}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.documentIndex &&
                            <TextField 
                                readOnly
                                label={t("Document Index")}
                                autoComplete={'off'} 
                                value={document.documentIndex} 
                                title={document.documentIndex}
                                styles={{root: {minWidth: 256}}}
                            />        
                        }
                        {document.supplierDocumentNumber &&
                            <TextField 
                                readOnly
                                label={t("SMS Document number")}
                                autoComplete={'off'} 
                                value={document.documentNumber} 
                                title={document.documentNumber}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.docType &&
                            <TextField 
                                readOnly
                                label={t("Document type")} 
                                autoComplete={'off'} 
                                value={document.docType.code + ' - ' + document.docType.name} 
                                title={document.docType.code + ' - ' + document.docType.name}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.discipline &&
                            <TextField 
                                readOnly
                                label={t("Discipline")} 
                                autoComplete={'off'} 
                                value={document.discipline.code + ' - ' + document.discipline.name} 
                                title={document.discipline.code + ' - ' + document.discipline.name}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.protectionClass &&
                            <TextField 
                                readOnly
                                label={t("Protection class")} 
                                autoComplete={'off'} 
                                value={document.protectionClass} 
                                title={document.protectionClass}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.protectionClass &&
                            <TextField 
                                readOnly
                                label={t("Usage")} 
                                autoComplete={'off'} 
                                value={document.usage} 
                                title={document.usage}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {project &&
                            <TextField 
                                readOnly
                                label={t("Project number")} 
                                autoComplete={'off'} 
                                value={project.projectName} 
                                title={project.projectName}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {project &&
                            <TextField 
                                readOnly
                                label="Project Codeword" 
                                autoComplete={'off'} 
                                value={project.projectCodeword} 
                                title={project.projectCodeword}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.plant &&
                            <TextField 
                                readOnly
                                label={t("Plant")} 
                                autoComplete={'off'} 
                                value={(document.plant.description) ? (document.plant.code + ' - ' + document.plant.description) : document.plant.code} 
                                title={(document.plant.description) ? (document.plant.code + ' - ' + document.plant.description) : document.plant.code} 
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.plantUnit &&
                            <TextField 
                                readOnly
                                label={t("Plant unit")} 
                                autoComplete={'off'} 
                                value={(document.plantUnit.description) ? (document.plantUnit.code + ' - ' + document.plantUnit.description) : document.plantUnit.code} 
                                title={(document.plantUnit.description) ? (document.plantUnit.code + ' - ' + document.plantUnit.description) : document.plantUnit.code} 
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.plantSection &&
                            <TextField 
                                readOnly
                                label={t("Plant section")} 
                                autoComplete={'off'} 
                                value={(document.plantSection.description) ? (document.plantSection.code + ' - ' + document.plantSection.description) : document.plantSection.code} 
                                title={(document.plantSection.description) ? (document.plantSection.code + ' - ' + document.plantSection.description) : document.plantSection.code} 
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.equipment &&
                            <TextField 
                                readOnly
                                label={t("Plant section")} 
                                autoComplete={'off'} 
                                value={(document.equipment.description) ? (document.equipment.code + ' - ' + document.equipment.description) : document.equipment.code} 
                                title={(document.equipment.description) ? (document.equipment.code + ' - ' + document.equipment.description) : document.equipment.code} 
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.entity &&
                            <TextField 
                                readOnly
                                 label={t("Entity")} 
                                autoComplete={'off'} 
                                value={document.entity.name} 
                                title={document.entity.name}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.sheet &&
                            <div>
                                <Label>{t('Sheet number')}</Label>
                                <NumericFormat
                                    key="sheet"
                                    readOnly
                                    customInput={TextField}
                                    decimalScale={0}
                                    value={(document.sheet) ? document.sheet : ''}
                                    title={(document.sheet) ? document.sheet.toString() as string : ''}
                                    autoComplete={'off'}
                                    styles={{root: {minWidth: 256}}}
                                />   
                            </div>       
                        }
                        {document.purpose &&
                            <TextField 
                                readOnly
                                label={t(getPurposeLabel(historyName))} 
                                autoComplete={'off'} 
                                value={document.purpose.description} 
                                title={document.purpose.description}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.transmittalId &&
                            <TextField 
                                readOnly
                                 label={t("Transmittal Id")} 
                                autoComplete={'off'} 
                                value={document.transmittalId} 
                                title={document.transmittalId}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                         {document.transmittalNumber &&
                            <TextField 
                                readOnly
                                 label={t("Transmittal N°")} 
                                autoComplete={'off'} 
                                value={document.transmittalNumber} 
                                title={document.transmittalNumber}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.responsible &&
                            <TextField 
                                readOnly
                                 label={t("Resposible")} 
                                autoComplete={'off'} 
                                value={document.responsible} 
                                title={document.responsible}
                                styles={{root: {minWidth: 256}}}
                            />          
                        }
                        {document.totalSheet !== undefined && document.totalSheet > 0 &&
                            <div>
                                <Label>{t('Total Sheet')}</Label>
                                <NumericFormat
                                    key="sheet"
                                    readOnly
                                    customInput={TextField}
                                    decimalScale={0}
                                    value={(document.totalSheet) ? document.totalSheet : ''}
                                    autoComplete={'off'}
                                    title={document.totalSheet.toString()}
                                    styles={{root: {minWidth: 256}}}
                                />   
                            </div>
                        }
                        {document.documentNumber &&
                            <TextField
                                readOnly
                                label={t("SMS Doc.Number")}
                                autoComplete={'off'}
                                value={document.documentNumber}
                                title={document.documentNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.type &&
                            <TextField
                                readOnly
                                label={t("Type")}
                                autoComplete={'off'}
                                value={document.type.name}
                                title={document.type.name}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.engPhase &&
                            <TextField
                                readOnly
                                label={t("Eng.Phase")}
                                autoComplete={'off'}
                                value={document.engPhase.name}
                                title={document.engPhase.name}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.format &&
                            <TextField
                                readOnly
                                label={t("Format")}
                                autoComplete={'off'}
                                value={document.format}
                                title={document.format}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.fileType &&
                            <TextField
                                readOnly
                                label={t("File type")}
                                autoComplete={'off'}
                                value={document.fileType}
                                title={document.fileType}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.scale &&
                            <TextField
                                readOnly
                                label={t("Scale")}
                                autoComplete={'off'}
                                value={document.scale}
                                title={document.scale}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.pbs &&
                            <TextField
                                readOnly
                                label={t("PBS Code")}
                                autoComplete={'off'}
                                value={document.pbs}
                                title={document.pbs}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.d3documentVersion &&
                            <TextField
                                readOnly
                                label={t("Variant number")}
                                autoComplete={'off'}
                                value={document.d3documentVersion}
                                title={document.d3documentVersion}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.wbsElement &&
                            <TextField
                                readOnly
                                label={t("WBS Element")}
                                autoComplete={'off'}
                                value={document.wbsElement}
                                title={document.wbsElement}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.competenceCentre &&
                            <TextField
                                readOnly
                                label={t("Competence Centre")}
                                autoComplete={'off'}
                                value={document.competenceCentre}
                                title={document.competenceCentre}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.linkedObject &&
                            <TextField
                                readOnly
                                label={t("Linked Object")}
                                autoComplete={'off'}
                                value={document.linkedObject}
                                title={document.linkedObject}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.linkedObjectNumber &&
                            <TextField
                                readOnly
                                label={t("Linked Object Number")}
                                autoComplete={'off'}
                                value={document.linkedObjectNumber}
                                title={document.linkedObjectNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.tosId &&
                            <TextField
                                readOnly
                                label={t("TOS Node Id")}
                                autoComplete={'off'}
                                value={document.tosId}
                                title={document.tosId}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.sapType &&
                            <TextField
                                readOnly
                                label={t("SAP Doc.Type")}
                                autoComplete={'off'}
                                value={document.sapType}
                                title={document.sapType}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.sapPart &&
                            <TextField
                                readOnly
                                label={t("SAP Doc.Part")}
                                autoComplete={'off'}
                                value={document.sapPart}
                                title={document.sapPart}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.author &&
                            <TextField
                                readOnly
                                label={t("Author")}
                                autoComplete={'off'}
                                value={document.author}
                                title={document.author}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.pss &&
                            <TextField
                                readOnly
                                label={t("PSS")}
                                autoComplete={'off'}
                                value={document.pss}
                                title={document.pss}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.neutralIndex &&
                            <TextField
                                readOnly
                                label={t("Neutral Index")}
                                autoComplete={'off'}
                                value={document.neutralIndex}
                                title={document.neutralIndex}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.source &&
                            <TextField
                                readOnly
                                label={t("Source")}
                                autoComplete={'off'}
                                value={document.source}
                                title={document.source}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.tsm &&
                            <TextField
                                readOnly
                                label={t("TSM")}
                                autoComplete={'off'}
                                value={document.tsm}
                                title={document.tsm}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.supplierDocIndex &&
                            <TextField
                                readOnly
                                label={t("Supplier Doc.Index")}
                                autoComplete={'off'}
                                value={document.supplierDocIndex}
                                title={document.supplierDocIndex}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.supplierDocNumber &&
                            <TextField
                                readOnly
                                label={t("Supplier Doc.Number")}
                                autoComplete={'off'}
                                value={document.supplierDocNumber}
                                title={document.supplierDocNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.customerDocNumber &&
                            <TextField
                                readOnly
                                label={t("Customer Doc.Number")}
                                autoComplete={'off'}
                                value={document.customerDocNumber}
                                title={document.customerDocNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.customerDocIndex &&
                            <TextField
                                readOnly
                                label={t("Customer Doc.Index")}
                                autoComplete={'off'}
                                value={document.customerDocIndex}
                                title={document.customerDocIndex}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.stakeHolders &&
                            <TextField
                                readOnly
                                label={t("Recipient Name")}
                                autoComplete={'off'}
                                value={document.stakeHolders}
                                title={document.stakeHolders}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.componentDesignationLanguage1 &&
                            <TextField
                                readOnly
                                label={t("Component Designation (language 1)")}
                                autoComplete={'off'}
                                value={document.componentDesignationLanguage1}
                                title={document.componentDesignationLanguage1}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.componentDesignationLanguage2 &&
                            <TextField
                                readOnly
                                label={t("Component Designation (language 2)")}
                                autoComplete={'off'}
                                value={document.componentDesignationLanguage2}
                                title={document.componentDesignationLanguage2}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.sizeDimensions &&
                            <TextField
                                readOnly
                                label={t("Size/Dimensions")}
                                autoComplete={'off'}
                                value={document.sizeDimensions}
                                title={document.sizeDimensions}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.clientNumber &&
                            <TextField
                                readOnly
                                label={t("Client Number")}
                                autoComplete={'off'}
                                value={document.clientNumber}
                                title={document.clientNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.tdNumber &&
                            <TextField
                                readOnly
                                label={t("TD Number")}
                                autoComplete={'off'}
                                value={document.tdNumber}
                                title={document.tdNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.tdSubject &&
                            <TextField
                                readOnly
                                label={t("TD Subject")}
                                autoComplete={'off'}
                                value={document.tdSubject}
                                title={document.tdSubject}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.engineeringElement &&
                            <TextField
                                readOnly
                                label={t("Engineering Element")}
                                autoComplete={'off'}
                                value={document.engineeringElement}
                                title={document.engineeringElement}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.customerRevision &&
                            <TextField
                                readOnly
                                label={t("Customer Revision")}
                                autoComplete={'off'}
                                value={document.customerRevision}
                                title={document.customerRevision}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.itemNumber &&
                            <TextField
                                readOnly
                                label={t("Item Number")}
                                autoComplete={'off'}
                                value={document.itemNumber}
                                title={document.itemNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.materialNumber &&
                            <TextField
                                readOnly
                                label={t("Material Number")}
                                autoComplete={'off'}
                                value={document.materialNumber}
                                title={document.materialNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.designation &&
                            <TextField
                                readOnly
                                label={t("Designation")}
                                autoComplete={'off'}
                                value={document.designation}
                                title={document.designation}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.appendix &&
                            <TextField
                                readOnly
                                label={t("Appendix")}
                                autoComplete={'off'}
                                value={document.appendix}
                                title={document.appendix}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.internalOrderNumber &&
                            <TextField
                                readOnly
                                label={t("Internal Order Number")}
                                autoComplete={'off'}
                                value={document.internalOrderNumber}
                                title={document.internalOrderNumber}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.publication !== undefined && document.publication > 0 &&
                            <div>
                                <Label>{t('Publication Number')}</Label>
                                <NumericFormat
                                    key="publication"
                                    readOnly
                                    customInput={TextField}
                                    decimalScale={0}
                                    value={document.publication}
                                    autoComplete={'off'}
                                    title={document.publication.toString()}
                                    styles={{root: {minWidth: 256}}}
                                />
                            </div>
                        }
                        {document.isForInternalUse === true &&
                            <TextField
                                readOnly
                                label={t("Show TD cover page")}
                                autoComplete={'off'}
                                value={t('Yes')}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.parentFilename &&
                            <TextField
                                readOnly
                                label={t("File name")}
                                autoComplete={'off'}
                                value={document.parentFilename}
                                title={document.parentFilename}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine1Pl &&
                            <TextField
                                readOnly
                                label={t("Title Line 1 (PL)")}
                                autoComplete={'off'}
                                value={document.titleLine1Pl}
                                title={document.titleLine1Pl}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine1En &&
                            <TextField
                                readOnly
                                label={t("Title Line 1 (EN)")}
                                autoComplete={'off'}
                                value={document.titleLine1En}
                                title={document.titleLine1En}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine2Pl &&
                            <TextField
                                readOnly
                                label={t("Title Line 2 (PL)")}
                                autoComplete={'off'}
                                value={document.titleLine2Pl}
                                title={document.titleLine2Pl}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine2En &&
                            <TextField
                                readOnly
                                label={t("Title Line 2 (EN)")}
                                autoComplete={'off'}
                                value={document.titleLine2En}
                                title={document.titleLine2En}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine3Pl &&
                            <TextField
                                readOnly
                                label={t("Title Line 3 (PL)")}
                                autoComplete={'off'}
                                value={document.titleLine3Pl}
                                title={document.titleLine3Pl}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine3En &&
                            <TextField
                                readOnly
                                label={t("Title Line 3 (EN)")}
                                autoComplete={'off'}
                                value={document.titleLine3En}
                                title={document.titleLine3En}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine4Pl &&
                            <TextField
                                readOnly
                                label={t("Title Line 4 (PL)")}
                                autoComplete={'off'}
                                value={document.titleLine4Pl}
                                title={document.titleLine4Pl}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine4En &&
                            <TextField
                                readOnly
                                label={t("Title Line 4 (EN)")}
                                autoComplete={'off'}
                                value={document.titleLine4En}
                                title={document.titleLine4En}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine5Pl &&
                            <TextField
                                readOnly
                                label={t("Title Line 5 (PL)")}
                                autoComplete={'off'}
                                value={document.titleLine5Pl}
                                title={document.titleLine5Pl}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine5En &&
                            <TextField
                                readOnly
                                label={t("Title Line 5 (EN)")}
                                autoComplete={'off'}
                                value={document.titleLine5En}
                                title={document.titleLine5En}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine6Pl &&
                            <TextField
                                readOnly
                                label={t("Title Line 6 (PL)")}
                                autoComplete={'off'}
                                value={document.titleLine6Pl}
                                title={document.titleLine6Pl}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                        {document.titleLine6En &&
                            <TextField
                                readOnly
                                label={t("Title Line 6 (EN)")}
                                autoComplete={'off'}
                                value={document.titleLine6En}
                                title={document.titleLine6En}
                                styles={{root: {minWidth: 256}}}
                            />
                        }
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    project: getSelectedProject
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
     
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(Details)));